export const BASE_API_URL = import.meta.env.VITE_BACKEND_DOMAIN;
export const FEDERATION_API_URL = import.meta.env.VITE_FEDERATION_DOMAIN;
export const NOTIFICATION_API_URL = import.meta.env.VITE_NOTIFICATION_SERVICE_DOMAIN;

export const KEYCLOAK_URL = import.meta.env.VITE_KEYCLOAK_URL;
export const KEYCLOAK_REALM = import.meta.env.VITE_KEYCLOAK_REALM;
export const KEYCLOAK_CLIENT_ID = import.meta.env.VITE_KEYCLOAK_CLIENT_ID;

export const WITH_SSO = import.meta.env.VITE_SSO === 'true';

export enum ApiRoutes {
	Bookings = 'booking',
	CarAccess = 'booking/car_access',
	Support = 'support',
	Objects = 'booking_object',
	BookingRootObjects = 'booking_object/root',
	BookingObjectActions = 'booking_object/actions',
	BookingObjectTypes = 'booking_object_type',
	Persons = 'person',
	PassTypes = 'pass_type',
	Passes = 'pass',
	Restrictions = 'restriction',
	Rating = 'rating',
	Relation = 'relation',
	References = 'help_content',
	Renters = 'renter',
	ScudMapping = 'scud_mapping',
}

export enum AuthorizationRoutes {
	Session = 'session',
}

export const ADMIN_PERMISSION_NAME = 'phs.booking.admin';

export const POLLING_INTERVAL = {
	SECURITY_BOOKINGS: 900000,
};
